import { render, staticRenderFns } from "./Mark-FixList.vue?vue&type=template&id=09813701&scoped=true&"
import script from "./Mark-FixList.vue?vue&type=script&lang=js&"
export * from "./Mark-FixList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09813701",
  null
  
)

export default component.exports